var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CHead',{attrs:{"oHead":_vm.Head}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('CGasto')],1),_c('div',{staticClass:"col-lg-6"},[_c('CAvance')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }